import { createElement } from 'react'
import { BundledDocumentSidebar } from './sidebar'
import { editablePageGroups } from '../../update-page-groups'
import type { STDocument } from '@st/sdk'
import { renderBundledDocumentViewerTopBar } from './top-bar'
import type { DocumentView } from '../types'

export function bundledDocumentView({
  document,
  baseView
}: {
  document: STDocument
  baseView: DocumentView
}): DocumentView | undefined {
  if (!document.permissions.includes('split')) {
    return undefined
  }

  return {
    ...baseView,
    pageGroups: () => editablePageGroups(document),
    viewerOptions: () => ({
      ...baseView.viewerOptions(),
      readOnly: false,
      pageGroupMode: 'enabled'
    }),
    renderTopBar: () => renderBundledDocumentViewerTopBar(),
    renderSidebar: ({ sendViewerMessage, fallback }) =>
      fallback ?? {
        title: 'Bundled document',
        content: createElement(BundledDocumentSidebar, { sendViewerMessage })
      }
  }
}
